var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#47BBA9",
    fillOpacity: 0.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99805,
    y: 8,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#47BBA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 56.6872C28.7751 56.6872 28.1875 57.2749 28.1875 57.9997C28.1875 58.7246 28.7751 59.3122 29.5 59.3122V56.6872ZM50.5 59.3122C51.2249 59.3122 51.8125 58.7246 51.8125 57.9997C51.8125 57.2749 51.2249 56.6872 50.5 56.6872V59.3122ZM51.8125 36.1247C51.8125 39.1111 49.9047 42.9735 47.2707 46.1817C45.9758 47.7589 44.5626 49.106 43.2313 50.0467C41.8592 51.0163 40.7397 51.4372 40 51.4372V54.0622C41.5572 54.0622 43.2267 53.2642 44.7462 52.1905C46.3066 51.0879 47.8874 49.5674 49.2995 47.8474C52.0796 44.4613 54.4375 40.0113 54.4375 36.1247H51.8125ZM40 51.4372C39.2868 51.4372 38.1791 50.9986 36.7992 49.9626C35.4657 48.9615 34.0488 47.531 32.7494 45.8666C30.1068 42.4819 28.1875 38.4435 28.1875 35.4442H25.5625C25.5625 39.3178 27.9088 43.9321 30.6803 47.482C32.0879 49.2849 33.6651 50.8921 35.2232 52.0619C36.735 53.1968 38.4163 54.0622 40 54.0622V51.4372ZM28.1875 35.4442C28.1875 29.0908 33.8375 24.3123 40 24.3123V21.6873C32.6315 21.6873 25.5625 27.4087 25.5625 35.4442H28.1875ZM40 24.3123C46.1142 24.3123 51.8125 29.0461 51.8125 36.1247H54.4375C54.4375 27.4534 47.4168 21.6873 40 21.6873V24.3123ZM43.9375 35.2497C43.9375 37.4244 42.1746 39.1872 40 39.1872V41.8122C43.6244 41.8122 46.5625 38.8741 46.5625 35.2497H43.9375ZM40 39.1872C37.8254 39.1872 36.0625 37.4244 36.0625 35.2497H33.4375C33.4375 38.8741 36.3756 41.8122 40 41.8122V39.1872ZM36.0625 35.2497C36.0625 33.0751 37.8254 31.3123 40 31.3123V28.6873C36.3756 28.6873 33.4375 31.6254 33.4375 35.2497H36.0625ZM40 31.3123C42.1746 31.3123 43.9375 33.0751 43.9375 35.2497H46.5625C46.5625 31.6254 43.6244 28.6873 40 28.6873V31.3123ZM29.5 59.3122H50.5V56.6872H29.5V59.3122Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.efce913bf8193f1844ab7c697491c8f4.svg";
export { ForwardRef as ReactComponent };